var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4645 10.9856L13.9611 6.33106C15.096 5.84622 18.9446 4.29468 18.9446 4.29468C18.9446 4.29468 20.7209 3.61593 20.5729 5.2644C20.5236 5.9432 20.1289 8.31896 19.7341 10.8887L18.5006 18.5008C18.5006 18.5008 18.4019 19.616 17.5631 19.8099C16.7243 20.0038 15.3427 19.1311 15.096 18.9372C14.8986 18.7917 11.3954 16.6099 10.1125 15.5432C9.76709 15.2523 9.37234 14.6705 10.1618 13.9917C11.9381 12.3917 14.0598 10.4038 15.3427 9.14322C15.9348 8.5614 16.5269 7.20381 14.0598 8.85229L7.10264 13.4584C7.10264 13.4584 6.31317 13.9432 4.83294 13.5069C3.35265 13.0705 1.62569 12.4887 1.62569 12.4887C1.62569 12.4887 0.441518 11.7614 2.4645 10.9856Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogin);
export default __webpack_public_path__ + "static/media/telegram-login.ab677cd00bb45e266c67af75c2796e8e.svg";
export { ForwardRef as ReactComponent };